import { useState, useMemo } from 'react';

import PeopleTable from '../../components/people/peopleTable';
import PageHeader from '../../components/general/pageHeader';
import SignUpForm from '../../components/forms/createUserForm';
import Loading from '../../components/general/loading.js';
import useAuthenticate from '../../components/authentication/authenticate.js';

const TenantsPage = () => {
  const tenantsRoles = useMemo(() => ['tenant'], []);
  const [showFilters, setShowFilters] = useState(false);

  const { isLoading } = useAuthenticate();

  return (
    <div className="w-full">
      <PageHeader pageName="Tenants" />
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="page-header" style={{ justifyContent: 'flex-end' }}>
            <button className='filter-button' onClick={() => setShowFilters(prev => !prev)}>
              <i className="fas fa-filter"></i>Filter
            </button>
            <SignUpForm onNewManagerProperty={() => { }} />
          </div>
          <PeopleTable rolesToShow={tenantsRoles} showFilters={showFilters} showRoleFilter={false} />
        </>
      )}
    </div>
  );
};

export default TenantsPage;
